export default __webpack_public_path__ + "static/media/less-equal.c32d98bb.svg";